import { INVENTORY_QUERY_FRAGMENT } from '../../../../common/inventory/services/InventoryService';
import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { DateUtils } from '../../../../common/utils/DateUtils';
import { OrganizationExportOptions } from '../../../options/OrganizationExportOptions';
import { OrganizationCsvMapper } from '../mappers/OrganizationCsvMapper';
import { OrganizationCsvData } from '../models/OrganizationCsvData';

export const GET_TRENDS_ORGANIZATION_CSV_QUERY = `
query ($tags: [String!], $projectIds: [String!], $profileIds: [String!], $includeExceptions: Boolean!, $overviewTypes: [OverviewType!], $fromDate: DateTime!, $toDate: DateTime!) {
  viewer {
    organization {
      overview(tags: $tags, projectIds: $projectIds, profileIds: $profileIds, overviewTypes: $overviewTypes, from: $fromDate, to: $toDate) {
        overviews {
          title
          overview {
            highInstances {
              count
            }
            mediumInstances {
              count
            }
            lowInstances {
              count
            }
            passedInstances {
              count
            }
          }
        }
      }
      vulnerabilities(tags: $tags, projectIds: $projectIds, profileIds: $profileIds, overviewTypes: $overviewTypes, withExceptions: $includeExceptions, from: $fromDate, to: $toDate) {
        edges {
          node {
            number
            title
            shortExplanation
            severity
            numberOfSlots
            project {
              id
              name
            }
          }
        }
      }
      inventory(tags: $tags, projectIds: $projectIds, profileIds: $profileIds, overviewTypes: $overviewTypes, from: $fromDate, to: $toDate) {
        ${INVENTORY_QUERY_FRAGMENT}
      }
    }
  }
}
`;

export class OrganizationCsvRepository extends BaseGQLService {
  private readonly mapper = new OrganizationCsvMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getTrendsOrganization(options: OrganizationExportOptions): Promise<OrganizationCsvData> {
    const { tags = [], projects = [], profiles = [], overviews = [], withExceptions, dateRange } = options;

    const [from, to] = dateRange;
    return this.query(
      GET_TRENDS_ORGANIZATION_CSV_QUERY,
      {
        tags,
        profileIds: profiles.map((p) => p.getId()),
        projectIds: projects.map((p) => p.getId()),
        includeExceptions: withExceptions,
        overviewTypes: overviews,
        fromDate: from !== null ? DateUtils.toISOString(from) : null,
        toDate: to !== null ? DateUtils.toISOString(to) : null,
      },
      (data) => this.mapper.mapGQLModel(data.viewer.organization, overviews, options.trends)
    );
  }
}
